<template>
    <div id="app">
        <!-- 登录页面或其他不需要布局的页面 -->
        <router-view v-if="!needsLayout" :key="$route.fullPath" />

        <!-- 主应用布局 -->
        <el-container v-else class="app-container">
            <!-- 左侧一级菜单 -->
            <el-aside width="200px" style="background: #e8e9fe">
                <Sidebar
                    :menuItems="menuItems"
                    :activeMenu="activeMenu"
                    @menu-change="handleMenuChange"
                />
            </el-aside>

            <el-container style="background: #e8e9fe">
                <el-main style="background: #e8e9fe">
                    <Header />

                    <!-- 二级水平菜单 (Tab) -->
                    <SecondaryMenu
                        :children="currentChildren"
                        :activeChild="activeChild"
                        @child-change="handleChildChange"
                    />

                    <!-- 二级路由渲染：强制刷新 -->
                    <router-view :key="routerViewKey" />
                </el-main>
            </el-container>
            <el-dialog title="信息提示" :visible.sync="showReviewMask" :show-close="false" width="500px" append-to-body>
                <div>
                    <!-- 审核中 -->
                    <div v-if="reviewStatus === 0" class="review-pending">
                        <h3>店铺审核中</h3>
                        <p style="margin-top: 10px">您的店铺正在审核中，请耐心等待...</p>
                    </div>
                    <!-- 审核未通过 -->
                    <div v-else-if="reviewStatus === 2">
                        <h3>店铺审核未通过</h3>
                        <p>很抱歉，您的店铺审核未通过</p>
                        <div class="rejection-reason">
                            <h4>未通过原因：</h4>
                            <div class="reason-content">{{ reason || '暂无具体原因，请联系客服' }}</div>
                        </div>
                        <el-button type="primary" @click="goToShopEdit">修改店铺信息</el-button>
                    </div>
                </div>
            </el-dialog>
        </el-container>
        <el-dialog title="注册信息编辑" :visible.sync="showRegister" :show-close="false" width="800px" append-to-body>
            <Register @registerSuccess="registerSuccess"></Register>
        </el-dialog>
      <!-- AI聊天机器人 - 放在这里 -->
      <AIChatbot v-if="needsLayout" />
    </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
import Header from './components/Header.vue'
import SecondaryMenu from './components/SecondaryMenu.vue'
import { getShopByUserId } from '@/api/login'
import { clearAuthData } from '@/util/cookie'
import Register from '@/components/Register.vue'
import AIChatbot from "@/components/AIChatbot.vue";

export default {
    name: 'App',
    components: {AIChatbot, Register, Sidebar, Header, SecondaryMenu },
    data() {
        return {
            reviewStatus: null,
            reason: '',
            showReviewMask: false,
            showRegister: false,
            routerViewKey: this.$route.fullPath, // 强制刷新 key
            menuItems: [
                {
                    name: 'Dashboard',
                    title: '仪表盘',
                    icon: 'el-icon-odometer',
                },
                {
                    name: 'IndustryKnowledge',
                    title: '行业知识',
                    icon: 'el-icon-reading',
                },
                {
                    name: 'NoteModule',
                    title: '内容创作',
                    icon: 'el-icon-document',
                    children: [
                        { name: 'NoteTextManage', title: '图文笔记创作', icon: 'el-icon-tickets', disabled: false },
                        {
                            name: 'NoteVideoManage',
                            title: '短视频一键转笔记',
                            icon: 'el-icon-video-camera',
                            disabled: false,
                        },
                        {
                            name: 'FileCopyManage',
                            title: '爆文结构复用',
                            icon: 'el-icon-video-camera',
                            disabled: false,
                        },
                        {
                            name: 'ShortVideoManage',
                            title: '短视频笔记创作',
                            icon: 'el-icon-video-camera',
                            disabled: false,
                        },
                        { name: 'NoteLiveManage', title: '笔记直播创作', icon: 'el-icon-video-camera', disabled: true },
                        // { name: 'TestManage', title: '测评管理', icon: 'el-icon-video-camera', disabled: true }
                    ],
                },
                { name: 'NoteManage', title: '笔记管理', icon: 'el-icon-document' },
                { name: 'ProductManage', title: '商品管理', icon: 'el-icon-edit-outline' },
                { name: 'OrderManage', title: '账单管理', icon: 'el-icon-s-order' },
            ],
            activeMenu: '',
            activeChild: '',
        }
    },
    //监听子组件emit

    computed: {
        needsLayout() {
            const noLayoutRoutes = ['/login', '/404']
            return !noLayoutRoutes.includes(this.$route.path)
        },
        currentChildren() {
            const parent = this.menuItems.find(i => i.name === this.activeMenu)
            return parent?.children || []
        },
    },
    watch: {
        '$route.fullPath': {
            immediate: true,
            handler(newPath) {
                // 每次路由变化时更新 key，强制销毁重建 router-view
                this.routerViewKey = newPath
                // 同时更新菜单状态
                const parent = this.menuItems.find(i => i.name === this.$route.name || i.children?.some(c => c.name === this.$route.name))
                if (parent) {
                    this.activeMenu = parent.name
                    if (parent.children?.length) {
                        this.activeChild = this.$route.name
                    } else {
                        this.activeChild = ''
                    }
                }
            },
        },
    },
    created() {
        this.checkShopStatus()
        var item = localStorage.getItem("user_info");
        if (item) {
            this.userInfo = JSON.parse(item);
            if (this.userInfo.id===1){
              this.menuItems= [
                {
                  name: 'Dashboard',
                  title: '仪表盘',
                  icon: 'el-icon-odometer',
                },
                {
                  name: 'IndustryKnowledge',
                  title: '行业知识',
                  icon: 'el-icon-reading',
                },
                {
                  name: 'NoteModule',
                  title: '内容创作',
                  icon: 'el-icon-document',
                  children: [
                    { name: 'NoteTextManage', title: '图文笔记创作', icon: 'el-icon-tickets', disabled: false },
                    {
                      name: 'NoteVideoManage',
                      title: '短视频一键转笔记',
                      icon: 'el-icon-video-camera',
                      disabled: false,
                    },
                    {
                      name: 'FileCopyManage',
                      title: '爆文结构复用',
                      icon: 'el-icon-video-camera',
                      disabled: false,
                    },
                    {
                      name: 'ShortVideoManage',
                      title: '短视频笔记创作',
                      icon: 'el-icon-video-camera',
                      disabled: false,
                    },
                    { name: 'NoteLiveManage', title: '笔记直播创作', icon: 'el-icon-video-camera', disabled: true },
                    // { name: 'TestManage', title: '测评管理', icon: 'el-icon-video-camera', disabled: true }
                  ],
                },
                { name: 'NoteManage', title: '笔记管理', icon: 'el-icon-document' },
                { name: 'TaskManage', title: '任务管理', icon: 'el-icon-s-data'},
              //  { name: 'ProductManage', title: '商品管理', icon: 'el-icon-edit-outline' },
               { name: 'OrderManage', title: '账单管理', icon: 'el-icon-s-order' },
              ]
            }
        }
    },
    methods: {
        registerSuccess(){
            this.showRegister = false
        },
        async checkShopStatus() {
            try {
                const userInfo = JSON.parse(localStorage.getItem('user_info') || '{}')
                if (!userInfo.id) return
                const res = await getShopByUserId(userInfo.id)
                if (res.code === 402) {
                    this.reviewStatus = 0
                    this.showReviewMask = true
                }
                if (res.code === 403) {
                    this.reviewStatus = 2
                    this.showReviewMask = true
                }
                if (this.reviewStatus === 2) this.reason = shop.reason || ''
            } catch (error) {
                console.error(error)
            }
        },
        refreshReviewStatus() {
            this.checkShopStatus()
        },
        goToShopEdit() {
            this.showReviewMask = false
            this.showRegister = true
        },
        handleMenuChange(name) {
            this.activeMenu = name
            if (this.currentChildren.length > 0) {
                this.activeChild = this.currentChildren[0].name
                this.$router.push({ name: this.activeChild })
            } else {
                this.activeChild = ''
                this.$router.push({ name })
            }
        },
        handleChildChange(name) {
            this.activeChild = name
            this.$router.push({ name })
        },
        handleLogout() {
            clearAuthData()
            this.$store?.commit('CLEAR_AUTH_DATA')
            this.$router.push('/login')
        },
    },
}
</script>

<style scoped>
/* 你已有的样式 */
</style>
